import { Y_AXIS } from '../utils';

interface YAxisRange {
  min: number;
  max: number;
}

/**
 * Calculate y-axis range to show more variation (don't always start at 0).
 * Exported for testing.
 */
export const calculateYAxisRange = (sparkline?: number[]): YAxisRange => {
  if (!sparkline || sparkline.length === 0) return { min: 0, max: 100 };
  const values = sparkline.filter((v) => v > 0);
  if (values.length === 0) return { min: 0, max: 100 };

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min;

  // If range is small relative to values, zoom in to show variation
  if (range < max * Y_AXIS.ZOOM_THRESHOLD) {
    const padding = Math.max(
      range * Y_AXIS.ZOOM_PADDING_MULTIPLIER,
      max * Y_AXIS.MIN_PADDING_MULTIPLIER
    );
    return {
      min: Math.max(0, min - padding),
      max: max + padding,
    };
  }
  return { min: 0, max: max * Y_AXIS.HEADROOM_MULTIPLIER };
};

/**
 * Check if sparkline data has any positive values.
 * Exported for testing.
 */
export const hasSparklineData = (sparkline?: number[]): boolean =>
  sparkline != null && sparkline.length > 0 && sparkline.some((v) => v > 0);
